import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'returnAgeOfCelebrant',
})
export class ReturnAgeOfCelebrantPipe implements PipeTransform {

  transform(birthdate: number): number {
    const birthDate = new Date(birthdate);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

}
